// This file is generated by scripts/generate-proto-crud-services.ts

// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension="
// @generated from file _gen.securitiesReportChunk.service.proto (package securitiesReportChunk.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from '@bufbuild/protobuf'
import { Message, proto3 } from '@bufbuild/protobuf'
import { SecuritiesReportChunk } from './_gen.models_pb'
import { Error } from './core_pb'

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunkByIdRequest
 */
export class GetSecuritiesReportChunkByIdRequest extends Message<GetSecuritiesReportChunkByIdRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunkByIdRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunkByIdRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunkByIdRequest {
    return new GetSecuritiesReportChunkByIdRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunkByIdRequest {
    return new GetSecuritiesReportChunkByIdRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunkByIdRequest {
    return new GetSecuritiesReportChunkByIdRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunkByIdRequest | PlainMessage<GetSecuritiesReportChunkByIdRequest> | undefined,
    b: GetSecuritiesReportChunkByIdRequest | PlainMessage<GetSecuritiesReportChunkByIdRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunkByIdRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunkByIdResponse
 */
export class GetSecuritiesReportChunkByIdResponse extends Message<GetSecuritiesReportChunkByIdResponse> {
  /**
   * @generated from field: models.SecuritiesReportChunk securitiesReportChunk = 1;
   */
  securitiesReportChunk?: SecuritiesReportChunk

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunkByIdResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunkByIdResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunk', kind: 'message', T: SecuritiesReportChunk },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunkByIdResponse {
    return new GetSecuritiesReportChunkByIdResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunkByIdResponse {
    return new GetSecuritiesReportChunkByIdResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunkByIdResponse {
    return new GetSecuritiesReportChunkByIdResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunkByIdResponse | PlainMessage<GetSecuritiesReportChunkByIdResponse> | undefined,
    b: GetSecuritiesReportChunkByIdResponse | PlainMessage<GetSecuritiesReportChunkByIdResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunkByIdResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByEdinetFileIdRequest
 */
export class GetSecuritiesReportChunksByEdinetFileIdRequest extends Message<GetSecuritiesReportChunksByEdinetFileIdRequest> {
  /**
   * @generated from field: string edinetFileId = 1;
   */
  edinetFileId = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByEdinetFileIdRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByEdinetFileIdRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'edinetFileId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByEdinetFileIdRequest {
    return new GetSecuritiesReportChunksByEdinetFileIdRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByEdinetFileIdRequest {
    return new GetSecuritiesReportChunksByEdinetFileIdRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByEdinetFileIdRequest {
    return new GetSecuritiesReportChunksByEdinetFileIdRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByEdinetFileIdRequest | PlainMessage<GetSecuritiesReportChunksByEdinetFileIdRequest> | undefined,
    b: GetSecuritiesReportChunksByEdinetFileIdRequest | PlainMessage<GetSecuritiesReportChunksByEdinetFileIdRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByEdinetFileIdRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByEdinetFileIdResponse
 */
export class GetSecuritiesReportChunksByEdinetFileIdResponse extends Message<GetSecuritiesReportChunksByEdinetFileIdResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByEdinetFileIdResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByEdinetFileIdResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByEdinetFileIdResponse {
    return new GetSecuritiesReportChunksByEdinetFileIdResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByEdinetFileIdResponse {
    return new GetSecuritiesReportChunksByEdinetFileIdResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByEdinetFileIdResponse {
    return new GetSecuritiesReportChunksByEdinetFileIdResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByEdinetFileIdResponse | PlainMessage<GetSecuritiesReportChunksByEdinetFileIdResponse> | undefined,
    b: GetSecuritiesReportChunksByEdinetFileIdResponse | PlainMessage<GetSecuritiesReportChunksByEdinetFileIdResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByEdinetFileIdResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksBySubmissionDateRequest
 */
export class GetSecuritiesReportChunksBySubmissionDateRequest extends Message<GetSecuritiesReportChunksBySubmissionDateRequest> {
  /**
   * @generated from field: string submissionDate = 1;
   */
  submissionDate = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksBySubmissionDateRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksBySubmissionDateRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'submissionDate', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksBySubmissionDateRequest {
    return new GetSecuritiesReportChunksBySubmissionDateRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksBySubmissionDateRequest {
    return new GetSecuritiesReportChunksBySubmissionDateRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksBySubmissionDateRequest {
    return new GetSecuritiesReportChunksBySubmissionDateRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksBySubmissionDateRequest | PlainMessage<GetSecuritiesReportChunksBySubmissionDateRequest> | undefined,
    b: GetSecuritiesReportChunksBySubmissionDateRequest | PlainMessage<GetSecuritiesReportChunksBySubmissionDateRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksBySubmissionDateRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksBySubmissionDateResponse
 */
export class GetSecuritiesReportChunksBySubmissionDateResponse extends Message<GetSecuritiesReportChunksBySubmissionDateResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksBySubmissionDateResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksBySubmissionDateResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksBySubmissionDateResponse {
    return new GetSecuritiesReportChunksBySubmissionDateResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksBySubmissionDateResponse {
    return new GetSecuritiesReportChunksBySubmissionDateResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksBySubmissionDateResponse {
    return new GetSecuritiesReportChunksBySubmissionDateResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksBySubmissionDateResponse | PlainMessage<GetSecuritiesReportChunksBySubmissionDateResponse> | undefined,
    b: GetSecuritiesReportChunksBySubmissionDateResponse | PlainMessage<GetSecuritiesReportChunksBySubmissionDateResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksBySubmissionDateResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByEdinetCodeRequest
 */
export class GetSecuritiesReportChunksByEdinetCodeRequest extends Message<GetSecuritiesReportChunksByEdinetCodeRequest> {
  /**
   * @generated from field: string edinetCode = 1;
   */
  edinetCode = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByEdinetCodeRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByEdinetCodeRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'edinetCode', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByEdinetCodeRequest {
    return new GetSecuritiesReportChunksByEdinetCodeRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByEdinetCodeRequest {
    return new GetSecuritiesReportChunksByEdinetCodeRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByEdinetCodeRequest {
    return new GetSecuritiesReportChunksByEdinetCodeRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByEdinetCodeRequest | PlainMessage<GetSecuritiesReportChunksByEdinetCodeRequest> | undefined,
    b: GetSecuritiesReportChunksByEdinetCodeRequest | PlainMessage<GetSecuritiesReportChunksByEdinetCodeRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByEdinetCodeRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByEdinetCodeResponse
 */
export class GetSecuritiesReportChunksByEdinetCodeResponse extends Message<GetSecuritiesReportChunksByEdinetCodeResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByEdinetCodeResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByEdinetCodeResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByEdinetCodeResponse {
    return new GetSecuritiesReportChunksByEdinetCodeResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByEdinetCodeResponse {
    return new GetSecuritiesReportChunksByEdinetCodeResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByEdinetCodeResponse {
    return new GetSecuritiesReportChunksByEdinetCodeResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByEdinetCodeResponse | PlainMessage<GetSecuritiesReportChunksByEdinetCodeResponse> | undefined,
    b: GetSecuritiesReportChunksByEdinetCodeResponse | PlainMessage<GetSecuritiesReportChunksByEdinetCodeResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByEdinetCodeResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksBySecCodeRequest
 */
export class GetSecuritiesReportChunksBySecCodeRequest extends Message<GetSecuritiesReportChunksBySecCodeRequest> {
  /**
   * @generated from field: string secCode = 1;
   */
  secCode = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksBySecCodeRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksBySecCodeRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'secCode', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksBySecCodeRequest {
    return new GetSecuritiesReportChunksBySecCodeRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksBySecCodeRequest {
    return new GetSecuritiesReportChunksBySecCodeRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksBySecCodeRequest {
    return new GetSecuritiesReportChunksBySecCodeRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksBySecCodeRequest | PlainMessage<GetSecuritiesReportChunksBySecCodeRequest> | undefined,
    b: GetSecuritiesReportChunksBySecCodeRequest | PlainMessage<GetSecuritiesReportChunksBySecCodeRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksBySecCodeRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksBySecCodeResponse
 */
export class GetSecuritiesReportChunksBySecCodeResponse extends Message<GetSecuritiesReportChunksBySecCodeResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksBySecCodeResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksBySecCodeResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksBySecCodeResponse {
    return new GetSecuritiesReportChunksBySecCodeResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksBySecCodeResponse {
    return new GetSecuritiesReportChunksBySecCodeResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksBySecCodeResponse {
    return new GetSecuritiesReportChunksBySecCodeResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksBySecCodeResponse | PlainMessage<GetSecuritiesReportChunksBySecCodeResponse> | undefined,
    b: GetSecuritiesReportChunksBySecCodeResponse | PlainMessage<GetSecuritiesReportChunksBySecCodeResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksBySecCodeResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByDocIdRequest
 */
export class GetSecuritiesReportChunksByDocIdRequest extends Message<GetSecuritiesReportChunksByDocIdRequest> {
  /**
   * @generated from field: string docId = 1;
   */
  docId = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByDocIdRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByDocIdRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'docId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByDocIdRequest {
    return new GetSecuritiesReportChunksByDocIdRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocIdRequest {
    return new GetSecuritiesReportChunksByDocIdRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocIdRequest {
    return new GetSecuritiesReportChunksByDocIdRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByDocIdRequest | PlainMessage<GetSecuritiesReportChunksByDocIdRequest> | undefined,
    b: GetSecuritiesReportChunksByDocIdRequest | PlainMessage<GetSecuritiesReportChunksByDocIdRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByDocIdRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByDocIdResponse
 */
export class GetSecuritiesReportChunksByDocIdResponse extends Message<GetSecuritiesReportChunksByDocIdResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByDocIdResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByDocIdResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByDocIdResponse {
    return new GetSecuritiesReportChunksByDocIdResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocIdResponse {
    return new GetSecuritiesReportChunksByDocIdResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocIdResponse {
    return new GetSecuritiesReportChunksByDocIdResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByDocIdResponse | PlainMessage<GetSecuritiesReportChunksByDocIdResponse> | undefined,
    b: GetSecuritiesReportChunksByDocIdResponse | PlainMessage<GetSecuritiesReportChunksByDocIdResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByDocIdResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByDocDescriptionRequest
 */
export class GetSecuritiesReportChunksByDocDescriptionRequest extends Message<GetSecuritiesReportChunksByDocDescriptionRequest> {
  /**
   * @generated from field: string docDescription = 1;
   */
  docDescription = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByDocDescriptionRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByDocDescriptionRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'docDescription', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByDocDescriptionRequest {
    return new GetSecuritiesReportChunksByDocDescriptionRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocDescriptionRequest {
    return new GetSecuritiesReportChunksByDocDescriptionRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocDescriptionRequest {
    return new GetSecuritiesReportChunksByDocDescriptionRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByDocDescriptionRequest | PlainMessage<GetSecuritiesReportChunksByDocDescriptionRequest> | undefined,
    b: GetSecuritiesReportChunksByDocDescriptionRequest | PlainMessage<GetSecuritiesReportChunksByDocDescriptionRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByDocDescriptionRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByDocDescriptionResponse
 */
export class GetSecuritiesReportChunksByDocDescriptionResponse extends Message<GetSecuritiesReportChunksByDocDescriptionResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByDocDescriptionResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByDocDescriptionResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByDocDescriptionResponse {
    return new GetSecuritiesReportChunksByDocDescriptionResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocDescriptionResponse {
    return new GetSecuritiesReportChunksByDocDescriptionResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocDescriptionResponse {
    return new GetSecuritiesReportChunksByDocDescriptionResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByDocDescriptionResponse | PlainMessage<GetSecuritiesReportChunksByDocDescriptionResponse> | undefined,
    b: GetSecuritiesReportChunksByDocDescriptionResponse | PlainMessage<GetSecuritiesReportChunksByDocDescriptionResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByDocDescriptionResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByPeriodStartRequest
 */
export class GetSecuritiesReportChunksByPeriodStartRequest extends Message<GetSecuritiesReportChunksByPeriodStartRequest> {
  /**
   * @generated from field: string periodStart = 1;
   */
  periodStart = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByPeriodStartRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByPeriodStartRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'periodStart', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByPeriodStartRequest {
    return new GetSecuritiesReportChunksByPeriodStartRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByPeriodStartRequest {
    return new GetSecuritiesReportChunksByPeriodStartRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByPeriodStartRequest {
    return new GetSecuritiesReportChunksByPeriodStartRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByPeriodStartRequest | PlainMessage<GetSecuritiesReportChunksByPeriodStartRequest> | undefined,
    b: GetSecuritiesReportChunksByPeriodStartRequest | PlainMessage<GetSecuritiesReportChunksByPeriodStartRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByPeriodStartRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByPeriodStartResponse
 */
export class GetSecuritiesReportChunksByPeriodStartResponse extends Message<GetSecuritiesReportChunksByPeriodStartResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByPeriodStartResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByPeriodStartResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByPeriodStartResponse {
    return new GetSecuritiesReportChunksByPeriodStartResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByPeriodStartResponse {
    return new GetSecuritiesReportChunksByPeriodStartResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByPeriodStartResponse {
    return new GetSecuritiesReportChunksByPeriodStartResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByPeriodStartResponse | PlainMessage<GetSecuritiesReportChunksByPeriodStartResponse> | undefined,
    b: GetSecuritiesReportChunksByPeriodStartResponse | PlainMessage<GetSecuritiesReportChunksByPeriodStartResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByPeriodStartResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByPeriodEndRequest
 */
export class GetSecuritiesReportChunksByPeriodEndRequest extends Message<GetSecuritiesReportChunksByPeriodEndRequest> {
  /**
   * @generated from field: string periodEnd = 1;
   */
  periodEnd = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByPeriodEndRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByPeriodEndRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'periodEnd', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByPeriodEndRequest {
    return new GetSecuritiesReportChunksByPeriodEndRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByPeriodEndRequest {
    return new GetSecuritiesReportChunksByPeriodEndRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByPeriodEndRequest {
    return new GetSecuritiesReportChunksByPeriodEndRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByPeriodEndRequest | PlainMessage<GetSecuritiesReportChunksByPeriodEndRequest> | undefined,
    b: GetSecuritiesReportChunksByPeriodEndRequest | PlainMessage<GetSecuritiesReportChunksByPeriodEndRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByPeriodEndRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByPeriodEndResponse
 */
export class GetSecuritiesReportChunksByPeriodEndResponse extends Message<GetSecuritiesReportChunksByPeriodEndResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByPeriodEndResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByPeriodEndResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByPeriodEndResponse {
    return new GetSecuritiesReportChunksByPeriodEndResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByPeriodEndResponse {
    return new GetSecuritiesReportChunksByPeriodEndResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByPeriodEndResponse {
    return new GetSecuritiesReportChunksByPeriodEndResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByPeriodEndResponse | PlainMessage<GetSecuritiesReportChunksByPeriodEndResponse> | undefined,
    b: GetSecuritiesReportChunksByPeriodEndResponse | PlainMessage<GetSecuritiesReportChunksByPeriodEndResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByPeriodEndResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByDocTypeCodeRequest
 */
export class GetSecuritiesReportChunksByDocTypeCodeRequest extends Message<GetSecuritiesReportChunksByDocTypeCodeRequest> {
  /**
   * @generated from field: string docTypeCode = 1;
   */
  docTypeCode = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByDocTypeCodeRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByDocTypeCodeRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'docTypeCode', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByDocTypeCodeRequest {
    return new GetSecuritiesReportChunksByDocTypeCodeRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocTypeCodeRequest {
    return new GetSecuritiesReportChunksByDocTypeCodeRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocTypeCodeRequest {
    return new GetSecuritiesReportChunksByDocTypeCodeRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByDocTypeCodeRequest | PlainMessage<GetSecuritiesReportChunksByDocTypeCodeRequest> | undefined,
    b: GetSecuritiesReportChunksByDocTypeCodeRequest | PlainMessage<GetSecuritiesReportChunksByDocTypeCodeRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByDocTypeCodeRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByDocTypeCodeResponse
 */
export class GetSecuritiesReportChunksByDocTypeCodeResponse extends Message<GetSecuritiesReportChunksByDocTypeCodeResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByDocTypeCodeResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByDocTypeCodeResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByDocTypeCodeResponse {
    return new GetSecuritiesReportChunksByDocTypeCodeResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocTypeCodeResponse {
    return new GetSecuritiesReportChunksByDocTypeCodeResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByDocTypeCodeResponse {
    return new GetSecuritiesReportChunksByDocTypeCodeResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByDocTypeCodeResponse | PlainMessage<GetSecuritiesReportChunksByDocTypeCodeResponse> | undefined,
    b: GetSecuritiesReportChunksByDocTypeCodeResponse | PlainMessage<GetSecuritiesReportChunksByDocTypeCodeResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByDocTypeCodeResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByFilerNameRequest
 */
export class GetSecuritiesReportChunksByFilerNameRequest extends Message<GetSecuritiesReportChunksByFilerNameRequest> {
  /**
   * @generated from field: string filerName = 1;
   */
  filerName = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByFilerNameRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByFilerNameRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'filerName', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByFilerNameRequest {
    return new GetSecuritiesReportChunksByFilerNameRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByFilerNameRequest {
    return new GetSecuritiesReportChunksByFilerNameRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByFilerNameRequest {
    return new GetSecuritiesReportChunksByFilerNameRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByFilerNameRequest | PlainMessage<GetSecuritiesReportChunksByFilerNameRequest> | undefined,
    b: GetSecuritiesReportChunksByFilerNameRequest | PlainMessage<GetSecuritiesReportChunksByFilerNameRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByFilerNameRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByFilerNameResponse
 */
export class GetSecuritiesReportChunksByFilerNameResponse extends Message<GetSecuritiesReportChunksByFilerNameResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByFilerNameResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByFilerNameResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByFilerNameResponse {
    return new GetSecuritiesReportChunksByFilerNameResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByFilerNameResponse {
    return new GetSecuritiesReportChunksByFilerNameResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByFilerNameResponse {
    return new GetSecuritiesReportChunksByFilerNameResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByFilerNameResponse | PlainMessage<GetSecuritiesReportChunksByFilerNameResponse> | undefined,
    b: GetSecuritiesReportChunksByFilerNameResponse | PlainMessage<GetSecuritiesReportChunksByFilerNameResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByFilerNameResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByOrdinanceCodeRequest
 */
export class GetSecuritiesReportChunksByOrdinanceCodeRequest extends Message<GetSecuritiesReportChunksByOrdinanceCodeRequest> {
  /**
   * @generated from field: string ordinanceCode = 1;
   */
  ordinanceCode = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByOrdinanceCodeRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByOrdinanceCodeRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'ordinanceCode', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByOrdinanceCodeRequest {
    return new GetSecuritiesReportChunksByOrdinanceCodeRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByOrdinanceCodeRequest {
    return new GetSecuritiesReportChunksByOrdinanceCodeRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByOrdinanceCodeRequest {
    return new GetSecuritiesReportChunksByOrdinanceCodeRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByOrdinanceCodeRequest | PlainMessage<GetSecuritiesReportChunksByOrdinanceCodeRequest> | undefined,
    b: GetSecuritiesReportChunksByOrdinanceCodeRequest | PlainMessage<GetSecuritiesReportChunksByOrdinanceCodeRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByOrdinanceCodeRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByOrdinanceCodeResponse
 */
export class GetSecuritiesReportChunksByOrdinanceCodeResponse extends Message<GetSecuritiesReportChunksByOrdinanceCodeResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByOrdinanceCodeResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByOrdinanceCodeResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByOrdinanceCodeResponse {
    return new GetSecuritiesReportChunksByOrdinanceCodeResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByOrdinanceCodeResponse {
    return new GetSecuritiesReportChunksByOrdinanceCodeResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByOrdinanceCodeResponse {
    return new GetSecuritiesReportChunksByOrdinanceCodeResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByOrdinanceCodeResponse | PlainMessage<GetSecuritiesReportChunksByOrdinanceCodeResponse> | undefined,
    b: GetSecuritiesReportChunksByOrdinanceCodeResponse | PlainMessage<GetSecuritiesReportChunksByOrdinanceCodeResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByOrdinanceCodeResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByFormCodeRequest
 */
export class GetSecuritiesReportChunksByFormCodeRequest extends Message<GetSecuritiesReportChunksByFormCodeRequest> {
  /**
   * @generated from field: string formCode = 1;
   */
  formCode = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByFormCodeRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByFormCodeRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'formCode', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByFormCodeRequest {
    return new GetSecuritiesReportChunksByFormCodeRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByFormCodeRequest {
    return new GetSecuritiesReportChunksByFormCodeRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByFormCodeRequest {
    return new GetSecuritiesReportChunksByFormCodeRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByFormCodeRequest | PlainMessage<GetSecuritiesReportChunksByFormCodeRequest> | undefined,
    b: GetSecuritiesReportChunksByFormCodeRequest | PlainMessage<GetSecuritiesReportChunksByFormCodeRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByFormCodeRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByFormCodeResponse
 */
export class GetSecuritiesReportChunksByFormCodeResponse extends Message<GetSecuritiesReportChunksByFormCodeResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByFormCodeResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByFormCodeResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByFormCodeResponse {
    return new GetSecuritiesReportChunksByFormCodeResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByFormCodeResponse {
    return new GetSecuritiesReportChunksByFormCodeResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByFormCodeResponse {
    return new GetSecuritiesReportChunksByFormCodeResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByFormCodeResponse | PlainMessage<GetSecuritiesReportChunksByFormCodeResponse> | undefined,
    b: GetSecuritiesReportChunksByFormCodeResponse | PlainMessage<GetSecuritiesReportChunksByFormCodeResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByFormCodeResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByOriginalFilenameRequest
 */
export class GetSecuritiesReportChunksByOriginalFilenameRequest extends Message<GetSecuritiesReportChunksByOriginalFilenameRequest> {
  /**
   * @generated from field: string originalFilename = 1;
   */
  originalFilename = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByOriginalFilenameRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByOriginalFilenameRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'originalFilename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByOriginalFilenameRequest {
    return new GetSecuritiesReportChunksByOriginalFilenameRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByOriginalFilenameRequest {
    return new GetSecuritiesReportChunksByOriginalFilenameRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByOriginalFilenameRequest {
    return new GetSecuritiesReportChunksByOriginalFilenameRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByOriginalFilenameRequest | PlainMessage<GetSecuritiesReportChunksByOriginalFilenameRequest> | undefined,
    b: GetSecuritiesReportChunksByOriginalFilenameRequest | PlainMessage<GetSecuritiesReportChunksByOriginalFilenameRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByOriginalFilenameRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByOriginalFilenameResponse
 */
export class GetSecuritiesReportChunksByOriginalFilenameResponse extends Message<GetSecuritiesReportChunksByOriginalFilenameResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByOriginalFilenameResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByOriginalFilenameResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByOriginalFilenameResponse {
    return new GetSecuritiesReportChunksByOriginalFilenameResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByOriginalFilenameResponse {
    return new GetSecuritiesReportChunksByOriginalFilenameResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByOriginalFilenameResponse {
    return new GetSecuritiesReportChunksByOriginalFilenameResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByOriginalFilenameResponse | PlainMessage<GetSecuritiesReportChunksByOriginalFilenameResponse> | undefined,
    b: GetSecuritiesReportChunksByOriginalFilenameResponse | PlainMessage<GetSecuritiesReportChunksByOriginalFilenameResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByOriginalFilenameResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByErrorMessageRequest
 */
export class GetSecuritiesReportChunksByErrorMessageRequest extends Message<GetSecuritiesReportChunksByErrorMessageRequest> {
  /**
   * @generated from field: string errorMessage = 1;
   */
  errorMessage = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByErrorMessageRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByErrorMessageRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'errorMessage', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByErrorMessageRequest {
    return new GetSecuritiesReportChunksByErrorMessageRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByErrorMessageRequest {
    return new GetSecuritiesReportChunksByErrorMessageRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByErrorMessageRequest {
    return new GetSecuritiesReportChunksByErrorMessageRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByErrorMessageRequest | PlainMessage<GetSecuritiesReportChunksByErrorMessageRequest> | undefined,
    b: GetSecuritiesReportChunksByErrorMessageRequest | PlainMessage<GetSecuritiesReportChunksByErrorMessageRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByErrorMessageRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByErrorMessageResponse
 */
export class GetSecuritiesReportChunksByErrorMessageResponse extends Message<GetSecuritiesReportChunksByErrorMessageResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByErrorMessageResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByErrorMessageResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByErrorMessageResponse {
    return new GetSecuritiesReportChunksByErrorMessageResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByErrorMessageResponse {
    return new GetSecuritiesReportChunksByErrorMessageResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByErrorMessageResponse {
    return new GetSecuritiesReportChunksByErrorMessageResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByErrorMessageResponse | PlainMessage<GetSecuritiesReportChunksByErrorMessageResponse> | undefined,
    b: GetSecuritiesReportChunksByErrorMessageResponse | PlainMessage<GetSecuritiesReportChunksByErrorMessageResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByErrorMessageResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByLayerRequest
 */
export class GetSecuritiesReportChunksByLayerRequest extends Message<GetSecuritiesReportChunksByLayerRequest> {
  /**
   * @generated from field: string layer = 1;
   */
  layer = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByLayerRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByLayerRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'layer', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByLayerRequest {
    return new GetSecuritiesReportChunksByLayerRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByLayerRequest {
    return new GetSecuritiesReportChunksByLayerRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByLayerRequest {
    return new GetSecuritiesReportChunksByLayerRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByLayerRequest | PlainMessage<GetSecuritiesReportChunksByLayerRequest> | undefined,
    b: GetSecuritiesReportChunksByLayerRequest | PlainMessage<GetSecuritiesReportChunksByLayerRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByLayerRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByLayerResponse
 */
export class GetSecuritiesReportChunksByLayerResponse extends Message<GetSecuritiesReportChunksByLayerResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByLayerResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByLayerResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByLayerResponse {
    return new GetSecuritiesReportChunksByLayerResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByLayerResponse {
    return new GetSecuritiesReportChunksByLayerResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByLayerResponse {
    return new GetSecuritiesReportChunksByLayerResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByLayerResponse | PlainMessage<GetSecuritiesReportChunksByLayerResponse> | undefined,
    b: GetSecuritiesReportChunksByLayerResponse | PlainMessage<GetSecuritiesReportChunksByLayerResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByLayerResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByTitlesStackRequest
 */
export class GetSecuritiesReportChunksByTitlesStackRequest extends Message<GetSecuritiesReportChunksByTitlesStackRequest> {
  /**
   * @generated from field: string titlesStack = 1;
   */
  titlesStack = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByTitlesStackRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByTitlesStackRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'titlesStack', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByTitlesStackRequest {
    return new GetSecuritiesReportChunksByTitlesStackRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTitlesStackRequest {
    return new GetSecuritiesReportChunksByTitlesStackRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTitlesStackRequest {
    return new GetSecuritiesReportChunksByTitlesStackRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByTitlesStackRequest | PlainMessage<GetSecuritiesReportChunksByTitlesStackRequest> | undefined,
    b: GetSecuritiesReportChunksByTitlesStackRequest | PlainMessage<GetSecuritiesReportChunksByTitlesStackRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByTitlesStackRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByTitlesStackResponse
 */
export class GetSecuritiesReportChunksByTitlesStackResponse extends Message<GetSecuritiesReportChunksByTitlesStackResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByTitlesStackResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByTitlesStackResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByTitlesStackResponse {
    return new GetSecuritiesReportChunksByTitlesStackResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTitlesStackResponse {
    return new GetSecuritiesReportChunksByTitlesStackResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTitlesStackResponse {
    return new GetSecuritiesReportChunksByTitlesStackResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByTitlesStackResponse | PlainMessage<GetSecuritiesReportChunksByTitlesStackResponse> | undefined,
    b: GetSecuritiesReportChunksByTitlesStackResponse | PlainMessage<GetSecuritiesReportChunksByTitlesStackResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByTitlesStackResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByTitleRequest
 */
export class GetSecuritiesReportChunksByTitleRequest extends Message<GetSecuritiesReportChunksByTitleRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByTitleRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByTitleRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByTitleRequest {
    return new GetSecuritiesReportChunksByTitleRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTitleRequest {
    return new GetSecuritiesReportChunksByTitleRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTitleRequest {
    return new GetSecuritiesReportChunksByTitleRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByTitleRequest | PlainMessage<GetSecuritiesReportChunksByTitleRequest> | undefined,
    b: GetSecuritiesReportChunksByTitleRequest | PlainMessage<GetSecuritiesReportChunksByTitleRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByTitleRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByTitleResponse
 */
export class GetSecuritiesReportChunksByTitleResponse extends Message<GetSecuritiesReportChunksByTitleResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByTitleResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByTitleResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByTitleResponse {
    return new GetSecuritiesReportChunksByTitleResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTitleResponse {
    return new GetSecuritiesReportChunksByTitleResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTitleResponse {
    return new GetSecuritiesReportChunksByTitleResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByTitleResponse | PlainMessage<GetSecuritiesReportChunksByTitleResponse> | undefined,
    b: GetSecuritiesReportChunksByTitleResponse | PlainMessage<GetSecuritiesReportChunksByTitleResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByTitleResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByParentChunkIdRequest
 */
export class GetSecuritiesReportChunksByParentChunkIdRequest extends Message<GetSecuritiesReportChunksByParentChunkIdRequest> {
  /**
   * @generated from field: string parentChunkId = 1;
   */
  parentChunkId = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByParentChunkIdRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByParentChunkIdRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'parentChunkId', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByParentChunkIdRequest {
    return new GetSecuritiesReportChunksByParentChunkIdRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByParentChunkIdRequest {
    return new GetSecuritiesReportChunksByParentChunkIdRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByParentChunkIdRequest {
    return new GetSecuritiesReportChunksByParentChunkIdRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByParentChunkIdRequest | PlainMessage<GetSecuritiesReportChunksByParentChunkIdRequest> | undefined,
    b: GetSecuritiesReportChunksByParentChunkIdRequest | PlainMessage<GetSecuritiesReportChunksByParentChunkIdRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByParentChunkIdRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByParentChunkIdResponse
 */
export class GetSecuritiesReportChunksByParentChunkIdResponse extends Message<GetSecuritiesReportChunksByParentChunkIdResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByParentChunkIdResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByParentChunkIdResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByParentChunkIdResponse {
    return new GetSecuritiesReportChunksByParentChunkIdResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByParentChunkIdResponse {
    return new GetSecuritiesReportChunksByParentChunkIdResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByParentChunkIdResponse {
    return new GetSecuritiesReportChunksByParentChunkIdResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByParentChunkIdResponse | PlainMessage<GetSecuritiesReportChunksByParentChunkIdResponse> | undefined,
    b: GetSecuritiesReportChunksByParentChunkIdResponse | PlainMessage<GetSecuritiesReportChunksByParentChunkIdResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByParentChunkIdResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByTrimmedChunkContentRequest
 */
export class GetSecuritiesReportChunksByTrimmedChunkContentRequest extends Message<GetSecuritiesReportChunksByTrimmedChunkContentRequest> {
  /**
   * @generated from field: string trimmedChunkContent = 1;
   */
  trimmedChunkContent = ''

  /**
   * @generated from field: string match = 2;
   */
  match = ''

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByTrimmedChunkContentRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByTrimmedChunkContentRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'trimmedChunkContent', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'match', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByTrimmedChunkContentRequest {
    return new GetSecuritiesReportChunksByTrimmedChunkContentRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTrimmedChunkContentRequest {
    return new GetSecuritiesReportChunksByTrimmedChunkContentRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTrimmedChunkContentRequest {
    return new GetSecuritiesReportChunksByTrimmedChunkContentRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByTrimmedChunkContentRequest | PlainMessage<GetSecuritiesReportChunksByTrimmedChunkContentRequest> | undefined,
    b: GetSecuritiesReportChunksByTrimmedChunkContentRequest | PlainMessage<GetSecuritiesReportChunksByTrimmedChunkContentRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByTrimmedChunkContentRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksByTrimmedChunkContentResponse
 */
export class GetSecuritiesReportChunksByTrimmedChunkContentResponse extends Message<GetSecuritiesReportChunksByTrimmedChunkContentResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksByTrimmedChunkContentResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksByTrimmedChunkContentResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksByTrimmedChunkContentResponse {
    return new GetSecuritiesReportChunksByTrimmedChunkContentResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTrimmedChunkContentResponse {
    return new GetSecuritiesReportChunksByTrimmedChunkContentResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksByTrimmedChunkContentResponse {
    return new GetSecuritiesReportChunksByTrimmedChunkContentResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksByTrimmedChunkContentResponse | PlainMessage<GetSecuritiesReportChunksByTrimmedChunkContentResponse> | undefined,
    b: GetSecuritiesReportChunksByTrimmedChunkContentResponse | PlainMessage<GetSecuritiesReportChunksByTrimmedChunkContentResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksByTrimmedChunkContentResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksRequest
 */
export class GetSecuritiesReportChunksRequest extends Message<GetSecuritiesReportChunksRequest> {
  constructor(data?: PartialMessage<GetSecuritiesReportChunksRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksRequest {
    return new GetSecuritiesReportChunksRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksRequest {
    return new GetSecuritiesReportChunksRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksRequest {
    return new GetSecuritiesReportChunksRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksRequest | PlainMessage<GetSecuritiesReportChunksRequest> | undefined,
    b: GetSecuritiesReportChunksRequest | PlainMessage<GetSecuritiesReportChunksRequest> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.GetSecuritiesReportChunksResponse
 */
export class GetSecuritiesReportChunksResponse extends Message<GetSecuritiesReportChunksResponse> {
  /**
   * @generated from field: repeated models.SecuritiesReportChunk securitiesReportChunks = 1;
   */
  securitiesReportChunks: SecuritiesReportChunk[] = []

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<GetSecuritiesReportChunksResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.GetSecuritiesReportChunksResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunks', kind: 'message', T: SecuritiesReportChunk, repeated: true },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSecuritiesReportChunksResponse {
    return new GetSecuritiesReportChunksResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksResponse {
    return new GetSecuritiesReportChunksResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSecuritiesReportChunksResponse {
    return new GetSecuritiesReportChunksResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: GetSecuritiesReportChunksResponse | PlainMessage<GetSecuritiesReportChunksResponse> | undefined,
    b: GetSecuritiesReportChunksResponse | PlainMessage<GetSecuritiesReportChunksResponse> | undefined,
  ): boolean {
    return proto3.util.equals(GetSecuritiesReportChunksResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.CreateSecuritiesReportChunkRequest
 */
export class CreateSecuritiesReportChunkRequest extends Message<CreateSecuritiesReportChunkRequest> {
  /**
   * @generated from field: models.SecuritiesReportChunk securitiesReportChunk = 1;
   */
  securitiesReportChunk?: SecuritiesReportChunk

  constructor(data?: PartialMessage<CreateSecuritiesReportChunkRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.CreateSecuritiesReportChunkRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'securitiesReportChunk', kind: 'message', T: SecuritiesReportChunk }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSecuritiesReportChunkRequest {
    return new CreateSecuritiesReportChunkRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSecuritiesReportChunkRequest {
    return new CreateSecuritiesReportChunkRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSecuritiesReportChunkRequest {
    return new CreateSecuritiesReportChunkRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: CreateSecuritiesReportChunkRequest | PlainMessage<CreateSecuritiesReportChunkRequest> | undefined,
    b: CreateSecuritiesReportChunkRequest | PlainMessage<CreateSecuritiesReportChunkRequest> | undefined,
  ): boolean {
    return proto3.util.equals(CreateSecuritiesReportChunkRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.CreateSecuritiesReportChunkResponse
 */
export class CreateSecuritiesReportChunkResponse extends Message<CreateSecuritiesReportChunkResponse> {
  /**
   * @generated from field: models.SecuritiesReportChunk securitiesReportChunk = 1;
   */
  securitiesReportChunk?: SecuritiesReportChunk

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<CreateSecuritiesReportChunkResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.CreateSecuritiesReportChunkResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunk', kind: 'message', T: SecuritiesReportChunk },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSecuritiesReportChunkResponse {
    return new CreateSecuritiesReportChunkResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSecuritiesReportChunkResponse {
    return new CreateSecuritiesReportChunkResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSecuritiesReportChunkResponse {
    return new CreateSecuritiesReportChunkResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: CreateSecuritiesReportChunkResponse | PlainMessage<CreateSecuritiesReportChunkResponse> | undefined,
    b: CreateSecuritiesReportChunkResponse | PlainMessage<CreateSecuritiesReportChunkResponse> | undefined,
  ): boolean {
    return proto3.util.equals(CreateSecuritiesReportChunkResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.UpdateSecuritiesReportChunkRequest
 */
export class UpdateSecuritiesReportChunkRequest extends Message<UpdateSecuritiesReportChunkRequest> {
  /**
   * @generated from field: models.SecuritiesReportChunk securitiesReportChunk = 1;
   */
  securitiesReportChunk?: SecuritiesReportChunk

  constructor(data?: PartialMessage<UpdateSecuritiesReportChunkRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.UpdateSecuritiesReportChunkRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'securitiesReportChunk', kind: 'message', T: SecuritiesReportChunk }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSecuritiesReportChunkRequest {
    return new UpdateSecuritiesReportChunkRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSecuritiesReportChunkRequest {
    return new UpdateSecuritiesReportChunkRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSecuritiesReportChunkRequest {
    return new UpdateSecuritiesReportChunkRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: UpdateSecuritiesReportChunkRequest | PlainMessage<UpdateSecuritiesReportChunkRequest> | undefined,
    b: UpdateSecuritiesReportChunkRequest | PlainMessage<UpdateSecuritiesReportChunkRequest> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateSecuritiesReportChunkRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.UpdateSecuritiesReportChunkResponse
 */
export class UpdateSecuritiesReportChunkResponse extends Message<UpdateSecuritiesReportChunkResponse> {
  /**
   * @generated from field: models.SecuritiesReportChunk securitiesReportChunk = 1;
   */
  securitiesReportChunk?: SecuritiesReportChunk

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<UpdateSecuritiesReportChunkResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.UpdateSecuritiesReportChunkResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunk', kind: 'message', T: SecuritiesReportChunk },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSecuritiesReportChunkResponse {
    return new UpdateSecuritiesReportChunkResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSecuritiesReportChunkResponse {
    return new UpdateSecuritiesReportChunkResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSecuritiesReportChunkResponse {
    return new UpdateSecuritiesReportChunkResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: UpdateSecuritiesReportChunkResponse | PlainMessage<UpdateSecuritiesReportChunkResponse> | undefined,
    b: UpdateSecuritiesReportChunkResponse | PlainMessage<UpdateSecuritiesReportChunkResponse> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateSecuritiesReportChunkResponse, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.DeleteSecuritiesReportChunkRequest
 */
export class DeleteSecuritiesReportChunkRequest extends Message<DeleteSecuritiesReportChunkRequest> {
  /**
   * @generated from field: models.SecuritiesReportChunk securitiesReportChunk = 1;
   */
  securitiesReportChunk?: SecuritiesReportChunk

  constructor(data?: PartialMessage<DeleteSecuritiesReportChunkRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.DeleteSecuritiesReportChunkRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [{ no: 1, name: 'securitiesReportChunk', kind: 'message', T: SecuritiesReportChunk }])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSecuritiesReportChunkRequest {
    return new DeleteSecuritiesReportChunkRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSecuritiesReportChunkRequest {
    return new DeleteSecuritiesReportChunkRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSecuritiesReportChunkRequest {
    return new DeleteSecuritiesReportChunkRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: DeleteSecuritiesReportChunkRequest | PlainMessage<DeleteSecuritiesReportChunkRequest> | undefined,
    b: DeleteSecuritiesReportChunkRequest | PlainMessage<DeleteSecuritiesReportChunkRequest> | undefined,
  ): boolean {
    return proto3.util.equals(DeleteSecuritiesReportChunkRequest, a, b)
  }
}

/**
 * @generated from message securitiesReportChunk.v1.DeleteSecuritiesReportChunkResponse
 */
export class DeleteSecuritiesReportChunkResponse extends Message<DeleteSecuritiesReportChunkResponse> {
  /**
   * @generated from field: models.SecuritiesReportChunk securitiesReportChunk = 1;
   */
  securitiesReportChunk?: SecuritiesReportChunk

  /**
   * @generated from field: core.Error error = 10001;
   */
  error?: Error

  constructor(data?: PartialMessage<DeleteSecuritiesReportChunkResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'securitiesReportChunk.v1.DeleteSecuritiesReportChunkResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'securitiesReportChunk', kind: 'message', T: SecuritiesReportChunk },
    { no: 10001, name: 'error', kind: 'message', T: Error },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSecuritiesReportChunkResponse {
    return new DeleteSecuritiesReportChunkResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSecuritiesReportChunkResponse {
    return new DeleteSecuritiesReportChunkResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSecuritiesReportChunkResponse {
    return new DeleteSecuritiesReportChunkResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: DeleteSecuritiesReportChunkResponse | PlainMessage<DeleteSecuritiesReportChunkResponse> | undefined,
    b: DeleteSecuritiesReportChunkResponse | PlainMessage<DeleteSecuritiesReportChunkResponse> | undefined,
  ): boolean {
    return proto3.util.equals(DeleteSecuritiesReportChunkResponse, a, b)
  }
}
